import { useQuery } from "@tanstack/react-query";
import { unitsApi, UNITS_NEEDS_LOCKBOX_COUNT_KEY } from "api/units";

// The menu badge remounts on every navigation; a short staleTime keeps that from
// re-counting each time. Lockbox changes invalidate the key explicitly.
const STALE_TIME_MS = 30_000;

// Available self-guided units with no lockbox linked, across every property the
// user can access. Search and filters never change it, so the Units menu badge
// and the Units page banner always show the same number.
export const useNeedsLockboxCount = ({
  enabled = true,
  refetchOnMount = true
}: {
  enabled?: boolean;
  refetchOnMount?: boolean | "always";
} = {}) => {
  const { data } = useQuery({
    queryKey: [UNITS_NEEDS_LOCKBOX_COUNT_KEY],
    queryFn: unitsApi.getNeedsLockboxCount,
    enabled,
    refetchOnMount,
    staleTime: STALE_TIME_MS
  });

  return data?.count ?? 0;
};
